import { render, staticRenderFns } from "./CarouselEconomicCalendar.vue?vue&type=template&id=8f1f7f6c&scoped=true"
import script from "./CarouselEconomicCalendar.vue?vue&type=script&lang=js"
export * from "./CarouselEconomicCalendar.vue?vue&type=script&lang=js"
import style0 from "./CarouselEconomicCalendar.vue?vue&type=style&index=0&id=8f1f7f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1f7f6c",
  null
  
)

export default component.exports